const config = {
  CLOUDFRONT_URL: 'https://d1ojj6tymrwk1h.cloudfront.net',
};

export default config;
